module.exports = "https://coursera_assets.s3.amazonaws.com/images/232f1e325075482dec2534a2fa097339.png";